import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-domain-registration',
  templateUrl: './domain-registration.component.html',
  styleUrls: ['./domain-registration.component.scss']
})
export class DomainRegistrationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
